import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import accountInfo from './modules/account-info'
import navMenu from './modules/nav-menu'
import tabsMenu from './modules/tabs-menu'
import cacheComponent from "./modules/cache-component";
import serviceTerminal from "./modules/service-terminal";

export default createStore({
  modules: {
    accountInfo,
    navMenu,
    tabsMenu,
    cacheComponent,
    serviceTerminal
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key:'vuex',
      paths: ['accountInfo','serviceTerminal']
    })
  ]
})
